import { useTranslation } from 'react-i18next'
import './WarningCount.scss'
interface Props {
  showOrderWarningCount: boolean
  totalActionRequired: number
  totalFrozenOrders: number
}

export function OrderWarningCount({ showOrderWarningCount, totalActionRequired, totalFrozenOrders }: Props) {
  const { t } = useTranslation('common')
  return (
    showOrderWarningCount && (
      <div className="orderWarningCount">
        {totalActionRequired > 0 && (
          <span title={t('ACTION_REQUIRED')}>
            <i className="icon-warning"></i>
            {totalActionRequired}
          </span>
        )}
        {totalFrozenOrders > 0 && (
          <span title={t('FROZEN_ORDER')}>
            <i className="icon-delivery"></i>
            {totalFrozenOrders}
          </span>
        )}
      </div>
    )
  )
}
